import React from "react";
import { useCompanySizes } from "newui/features/Company/hooks/useCompanySizes";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface CompanySizeSelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	profileType?: number;
	selectedId?: number | "";
}

export const CompanySizeSelect: React.FC<CompanySizeSelectProps> = ({
	label = "Company Size",
	placeholder = "Select company size",
	profileType,
	selectedId,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const { values, isLoading } = useCompanySizes(profileType, false);
	const formik = useFormikFieldState(name);

	const resolvedValue = selectedId !== undefined
		? isLoading
			? undefined
			: values.find((s) => s.value === selectedId) ?? null
		: valueProp;

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={values as SelectOption[]}
			isLoading={isLoading}
			label={label}
			placeholder={placeholder}
			value={resolvedValue}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			{...rest}
		/>
	);
};
